import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";

import { useStores } from "@stores";
import { media } from "@themes/breakpoints";
import { theme } from "@themes/themes";

export const GeoRestrictionBanner = observer(() => {
  const { t } = useTranslation();
  const { geoFenceStore } = useStores();

  if (!geoFenceStore.isRestricted) {
    return null;
  }

  return (
    <Banner data-testid="geofence:banner">
      {t("geoFence.bannerMessage")}{" "}
      <a href="https://docs.ekiden.fi/" rel="noreferrer" target="_blank">
        {t("geoFence.termsLink")}
      </a>{" "}
      {t("geoFence.supportHint")}{" "}
      <a href="https://discord.com/invite/37682NeRb3" rel="noreferrer" target="_blank">
        {t("geoFence.supportLink")}
      </a>
      .
    </Banner>
  );
});

const Banner = styled.div`
  width: 100%;
  min-height: fit-content;
  padding: 10px 16px;
  background: ${theme.color("red-strong")};
  border-bottom: 1px solid ${theme.color("red-medium")};
  z-index: 110;
  ${theme.font.body12};
  color: ${theme.color("accent-contrast")};
  line-height: 1.3;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: center;

  ${media.mobile} {
    padding: 8px 10px 9px;
    text-align: left;
    font-size: 11px;
  }

  a {
    color: ${theme.color("accent-contrast")};
    text-decoration: underline;
    text-underline-offset: 2px;
    font-weight: 600;
  }
`;
